import { env } from "../env"

export async function downloadExport(url: string, filename: string, params?: Record<string, string | undefined>) {
  const searchParams = new URLSearchParams()
  if (params) {
    for (const [key, value] of Object.entries(params)) {
      if (value != null && value !== "") {
        searchParams.set(key, value)
      }
    }
  }
  const query = searchParams.toString()
  const fullUrl = `${env.apiUrl}${url}${query ? `?${query}` : ""}`

  const response = await fetch(fullUrl, { credentials: "include" })
  if (!response.ok) throw new Error(`Export failed: ${response.statusText}`)

  const blob = await response.blob()
  const blobUrl = window.URL.createObjectURL(blob)
  const a = document.createElement("a")
  a.href = blobUrl
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(blobUrl)
}
